/**
 * Reseller dashboard layout route — eagerly registers the file route; the layout
 * component and its atom/RPC imports are deferred to `reseller.lazy.tsx` so they
 * load only with this route, never in the always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import { requireAuth } from "~/lib/server-auth.ts";

/**
 * This is the reseller *layout* route, so the guard below runs ahead of every
 * child screen (`reseller/index` and any future one): a signed-out visitor is
 * sent to the brand login by {@link requireAuth} before any authed atom fires.
 * Mirrors `routes/clawinstall/dashboard.tsx`.
 *
 * IMPORTANT: Do NOT wrap requireAuth in Effect — TanStack redirects must be
 * thrown directly, not wrapped in Effect which turns them into FiberFailures.
 */
export const Route = createFileRoute("/clawinstall/reseller")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
    const auth = await requireAuth();
    return { auth };
  },
});
